import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { AbstractFormComponent } from '../../../../../shared/crud/component/form.component';
import { ApiKeyForm } from './apikey.form';
import { BsModalService } from 'ngx-bootstrap/modal';
import { AbstractPresetFormComponent } from '../../preset-form.component';
import { PhotocodeTemplateForm } from '../../photocode-template/form/photocode-template.form';
import { AdminUrlBuilder } from '../../../../../shared/admin/api/admin-url-builder';
import { CampaignUrlBuilder } from '../../../../campaign-util/shared/url-builder';
import { CampaignId } from '../../../../campaign-util/shared/campaign-id';
import { EventBus } from '../../../../../shared/event/bus';
import { ErrorCodes } from '../../../../../shared/enum/api-errors';

@Component({
  selector: 'admin-apikey-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
})

export class AdminApiKeyFormComponent extends AbstractPresetFormComponent implements OnInit, AfterViewInit {

  @Input() row: any;
  @Input() selectedRowId: number;
  @Output() makeDefault = new EventEmitter();
  @Output() delete = new EventEmitter();
  @Output() saved = new EventEmitter();
  isEditMode: boolean = false;

  constructor(formBuilder: ApiKeyForm,
              httpClient: HttpClient,
              toastrService: ToastrService,
              crudUrlBuilder: AdminUrlBuilder,
              private campaignUrlBuilder: CampaignUrlBuilder,
              router: Router,
              route: ActivatedRoute,
              campaignId: CampaignId,
              eventBus: EventBus) {
    super(formBuilder, httpClient, toastrService, crudUrlBuilder, router, route, campaignId, eventBus);
  }

  ngOnInit() {
    super.ngOnInit();
    this.formatRow();
    this.record = this.row;
    this.form.patchValue(this.row);
  }

  ngAfterViewInit() {
    if (this.row.id) {
      this.formMode = 'update';
      this.form.reset(this.row);
    } else {
      this.formMode = 'create';
    }
  }

  formatRow() {
    this.row.policy = JSON.stringify(JSON.parse(this.row.policy), null, '\t');
  }

  protected getUrl(forceId?: number): string {
    const params = this.route.snapshot.params;
    return '/api-keys' + (params.id ? `/${params.id}` : forceId ? `/${forceId}` : '');
  }

  protected onSubmit(response: any): void {
    this.editRow();
  }


  submit(): void {
    if (!this.form.controls.name.value) {
      this.toastrService.error('Enter name');
      return;
    }
    if (!this.form.controls.policy) {
      this.toastrService.error('Enter policy');
      return;
    }
    const url = this.urlBuilder.buildUrl(this.getUrl(this.record.id));
    const method = typeof this.record.id === 'undefined' ? this.httpClient.post : this.httpClient.put;
    this.savePromise = method.call(this.httpClient, url, {
      ...this.form.value,
    })
      .subscribe((response: any) => {
        this.record.id = response.id;
        this.toastrService.success('Saved');
        this.row.__editing = false;
        this.row.id = response.id;
        this.saved.emit();
        return response;
      }, (error: any) => {
        this.toastrService.error(error.error ? (error.error.message || ErrorCodes[error.error.code] || 'Something went wrong...') : 'Error');
        return error;
      });
  }

  editRow() {
    this.isEditMode = !this.isEditMode;
  }

  copyToClipboard() {
    navigator.clipboard.writeText(this.row.apiKey).then(() => {
      this.toastrService.success('Copied');
    }).catch(err => {
      this.toastrService.error('Error');
    });
  }
}
